// Models
import { PeerStats } from 'src/app/models/peer-stats/peer-stats';

export class StatsParser {
  parse(participantId: string, stat: any, report: PeerStats, sharing = false): void {
    let r = report?.participantsStats[participantId];
    if (sharing) {
      r = report?.shareStats[participantId];
    }

    if (r) {
      if (stat.type === 'inbound-rtp') {
        if (stat.kind === 'audio') {
          r.audio.bytesReceived = stat.bytesReceived;
          r.audio.packetsLost = stat.packetsLost;
          r.audio.packetsReceived = stat.packetsReceived;
          r.audio.receivedTimestamp = stat.timestamp;
          if (typeof stat.jitter !== 'undefined') {
            r.audio.jitterIn = stat.jitter;
          } else {
            r.audio.jitterIn = 0;
          }
          if (typeof stat.estimatedPlayoutTimestamp !== 'undefined') {
            r.audio.estimatedPlayoutTimestamp = stat.estimatedPlayoutTimestamp;
          }
        } else if (stat.kind === 'video') {
          r.video.bytesReceived = stat.bytesReceived;
          r.video.packetsLost = stat.packetsLost;
          r.video.packetsReceived = stat.packetsReceived;
          r.video.receivedTimestamp = stat.timestamp;
          r.video.totalDecodeTime = stat.totalDecodeTime;
          r.video.framesDecoded = stat.framesDecoded;
          r.video.frameWidthIn = stat.frameWidth;
          r.video.frameHeightIn = stat.frameHeight;
          if (typeof stat.estimatedPlayoutTimestamp !== 'undefined') {
            r.video.estimatedPlayoutTimestamp = stat.estimatedPlayoutTimestamp;
          }
          if (typeof stat.jitter !== 'undefined') {
            r.video.jitterIn = stat.jitter;
          } else {
            r.video.jitterIn = 0;
          }
        }
      } else if (stat.type === 'outbound-rtp') {
        if (stat.kind === 'audio') {
          r.audio.bytesSent = stat.bytesSent;
          r.audio.sentTimestamp = stat.timestamp;
        } else if (stat.kind === 'video') {
          r.video.bytesSent = stat.bytesSent;
          r.video.totalEncodeTime = stat.totalEncodeTime;
          r.video.framesEncoded = stat.framesEncoded;
          r.video.sentTimestamp = stat.timestamp;
          r.video.frameWidthOut = stat.frameWidth;
          r.video.frameHeightOut = stat.frameHeight;
        }
      } else if (stat.type === 'remote-inbound-rtp') {
        if (stat.kind === 'audio') {
          r.audio.roundTripTime = stat.roundTripTime;
          if (typeof stat.jitter !== 'undefined') {
            r.audio.jitterOut = stat.jitter;
          } else {
            r.audio.jitterOut = 0;
          }
        } else if (stat.kind === 'video') {
          r.video.roundTripTime = stat.roundTripTime;
          if (typeof stat.jitter !== 'undefined') {
            r.video.jitterOut = stat.jitter;
          } else {
            r.video.jitterOut = 0;
          }
        }
      }
    }
  }
}
